import { useState } from "react";
import type { Message } from "@swift/shared";
import { api } from "../lib/api";
import { useStore } from "../lib/store";

const QUICK_EMOJI = ["👍", "❤️", "😂", "🎉", "👀", "🙏"];

export default function ReactionRow({ message }: { message: Message }) {
  const me = useStore((s) => s.me);
  const [picking, setPicking] = useState(false);

  const groups = new Map<string, number[]>();
  for (const r of message.reactions) {
    const list = groups.get(r.emoji) ?? [];
    list.push(r.user_id);
    groups.set(r.emoji, list);
  }

  async function toggle(emoji: string) {
    if (!me) return;
    const mine = message.reactions.some((r) => r.user_id === me.id && r.emoji === emoji);
    if (mine) await api.removeReaction(message.id, emoji);
    else await api.addReaction(message.id, emoji);
  }

  if (groups.size === 0 && !picking) {
    // hidden = neemt geen layout-ruimte; alleen tonen tijdens group-hover op
    // het ouder-bericht. Voorkomt de witregel tussen opeenvolgende berichten.
    return (
      <button
        onClick={() => setPicking(true)}
        className="mt-0.5 hidden text-[10px] text-slate-600 group-hover:inline-block hover:text-slate-300"
        aria-label="Reageer met emoji"
      >
        + reactie
      </button>
    );
  }
  return (
    <div className="mt-1 flex flex-wrap items-center gap-1">
      {Array.from(groups.entries()).map(([emoji, ids]) => {
        const mine = me ? ids.includes(me.id) : false;
        return (
          <button
            key={emoji}
            onClick={() => toggle(emoji)}
            className={`rounded-full border px-2 py-0.5 text-xs ${
              mine
                ? "border-accent bg-accent/20 text-slate-100"
                : "border-slate-700 bg-slate-800 text-slate-300 hover:bg-slate-700"
            }`}
          >
            {emoji} {ids.length}
          </button>
        );
      })}
      <button
        onClick={() => setPicking((p) => !p)}
        className="rounded-full border border-slate-700 bg-slate-800 px-2 py-0.5 text-xs text-slate-400 hover:bg-slate-700"
      >
        +
      </button>
      {picking && (
        <div className="flex gap-1">
          {QUICK_EMOJI.map((e) => (
            <button
              key={e}
              onClick={() => {
                void toggle(e);
                setPicking(false);
              }}
              className="rounded px-1 text-base hover:bg-slate-700"
            >
              {e}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
